import { Translation, QRType } from '../types';

export const fr: Translation = {
  nav: {
    generator: 'Générateur',
    scanner: 'Scanner',
    mobile: 'Essayer sur mobile',
    blog: 'Blog',
    langSelect: 'Choisir la langue',
  },
  pageTitles: {
    generator: 'Générateur de QR code gratuit en ligne',
    scanner: 'Scanner QR code en ligne',
    textToQr: 'Convertisseur de texte en QR code',
    linkToQr: 'Générateur de QR code pour liens',
  },
  pageMeta: {
    generator: {
      title:
        'Générateur de QR code gratuit — Créez des QR codes en ligne (sans inscription, sans filigrane, PNG/SVG/PDF) | YesQRCode',
      description:
        'Créez des QR codes en ligne gratuitement avec YesQRCode. Générez des codes pour URL, texte, Wi‑Fi, vCard et plus. Téléchargez des PNG, SVG ou PDF de haute qualité. Sans compte, sans connexion, sans filigrane — rapide, sécurisé et gratuit pour toujours.',
      keywords: [
        'générateur qr code',
        'générateur qr code gratuit',
        'créer qr code en ligne',
        'créateur qr code',
        'qr code png',
        'qr code svg',
        'qr code pdf',
        'générateur qr code wifi',
        'générateur qr code vcard',
        'générateur qr sans inscription',
      ],
    },
    scanner: {
      title:
        'Scanner QR code en ligne — Scanner depuis une image ou la caméra (sécurisé, sans inscription) | YesQRCode',
      description:
        'Scannez gratuitement des QR codes et des codes‑barres en ligne. Importez une image ou utilisez votre caméra. Tout le traitement se fait localement, sans envoi de fichiers. Sécurisé, rapide, sans inscription, sans connexion, et totalement gratuit.',
      keywords: [
        'scanner qr code',
        'scanner qr code en ligne',
        'lecteur qr en ligne',
        'scanner qr depuis image',
        'scanner code-barres en ligne',
        'scanner qr sécurisé',
        'scanner qr sans upload',
        'scanner qr gratuit',
        'scanner qr navigateur',
        'scanner qr sans inscription',
      ],
    },
    textToQr: {
      title: 'Texte en QR code | Transformez des notes en QR codes',
      description:
        'Convertissez des extraits de texte, des notes ou des messages en QR codes partageables. Personnalisez le style et exportez en PNG, SVG ou PDF instantanément, sans inscription.',
      keywords: [
        'texte en qr',
        'générateur qr texte',
        'qr code note',
        'qr message',
        'convertisseur qr en ligne',
        'qr texte gratuit',
      ],
    },
    linkToQr: {
      title: 'Lien en QR code | Convertissez des URLs en QR codes',
      description:
        'Collez n’importe quelle URL de site ou de campagne et générez instantanément un QR code prêt pour l’impression ou le numérique. Couleurs personnalisées, logos et téléchargements haute résolution.',
      keywords: [
        'lien en qr',
        'générateur qr url',
        'qr site web',
        'qr pour lien',
        'qr code utm',
        'télécharger qr pdf',
      ],
    },
  },
  hero: {
    title: 'Créez des QR codes privés, prêts pour votre marque — gratuit pour toujours.',
    subtitle: 'Un outil QR rapide, privé et flexible, adapté à tous les workflows.',
    desc: 'Générez et scannez des QR codes de haute qualité sans compte, sans filigrane et sans envoi de données.',
    ctaPrimary: 'Générer un QR code',
    ctaSecondary: 'Essayer sur mobile',
  },
  info: {
    helpTitle: "Centre d'aide",
    helpSubtitle: 'FAQ & assistance',
    contactTitle: 'Nous contacter',
    contactSubtitle: 'Nous serions ravis de vous lire.',
    privacyTitle: 'Politique de confidentialité',
    termsTitle: "Conditions d'utilisation",
  },
  contactForm: {
    name: 'Nom',
    email: 'E-mail',
    message: 'Message',
    send: 'Envoyer',
    orEmail: 'ou écrivez-nous directement à',
    sending: 'Envoi...',
    successTitle: 'Message envoyé !',
    successMessage: 'Merci de nous avoir contactés. Nous vous répondrons rapidement.',
    sendAnother: 'Envoyer un autre message',
    errorMessage:
      'Nous ne pouvons pas envoyer votre message pour le moment. Merci d’écrire à support@yesqrcode.com.',
  },
  generator: {
    highlights: {
      title: 'Créez des QR codes privés, prêts pour votre marque — gratuit pour toujours.',
      subtitle: 'Un outil QR rapide, privé et flexible, adapté à tous les workflows.',
      items: [
        {
          title: 'Confidentialité d’abord, génération sur l’appareil',
          desc: 'Les QR codes sont créés localement — aucun upload, aucun suivi, aucune donnée stockée.',
        },
        {
          title: 'Fonctionnalités riches pour tous les usages',
          desc: 'URLs, Wi‑Fi, vCards, codes‑barres, logos, dégradés, cadres — tout est intégré.',
        },
        {
          title: 'Compatible mobile et simple pour tous',
          desc: 'Optimisé pour les téléphones et le tactile pour une création et un scan fluides.',
        },
        {
          title: 'Gratuit pour toujours, utilisable commercialement',
          desc: 'Sans compte, sans filigrane, sans limite de scans — fiable pour toute équipe ou entreprise.',
        },
      ],
    },
    featureSuite: {
      title: 'La suite QR complète, axée sur la confidentialité',
      subtitle:
        'Tout ce qu’il vous faut pour créer des QR codes propres, personnalisés et de haute qualité — au même endroit.',
      categories: [
        {
          title: 'Tous les types de QR codes dont vous avez besoin',
          body: 'URL, Texte, Wi‑Fi, E-mail, Téléphone, SMS, vCard, réseaux sociaux, YouTube, codes‑barres. Des codes statiques qui n’expirent jamais.',
          items: [],
        },
        {
          title: 'Marque & Design',
          body: 'Codes compatibles logo, dégradés, cadres, formes, coins et mises en page optimisées pour le scan.',
          items: [],
        },
        {
          title: 'Export & Qualité',
          body: 'Exports PNG, SVG et PDF haute qualité, avec préréglages pour l’impression et le numérique.',
          items: [],
        },
        {
          title: 'International & Ergonomie',
          body: 'Interface multilingue, design mobile-first et usage friendly même hors ligne.',
          items: [],
        },
      ],
    },
    trust: {
      title: 'Approuvé par des créateurs, équipes et marques',
      subtitle:
        'YesQRCode est conçu pour être léger, prévisible et sûr pour les campagnes longue durée — sans compte, sans verrouillage fournisseur et sans limitations cachées.',
      items: [
        'Zéro onboarding',
        'Codes statiques prévisibles',
        'Compatible entreprise : aucun traitement cloud',
        'Image de marque cohérente sur tous les supports',
      ],
    },
    sectionContent: 'Contenu',
    sectionColors: 'Couleurs',
    sectionLogo: 'Logo',
    sectionFrame: 'Cadre',
    sectionDesign: 'Design',
    sectionCorrection: "Correction d'erreurs",
    labelUrl: 'URL du site',
    labelText: 'Texte brut',
    labelSsid: 'Nom du réseau (SSID)',
    labelPassword: 'Mot de passe',
    labelEncryption: 'Chiffrement',
    labelFgColor: 'Premier plan',
    labelBgColor: 'Arrière-plan',
    labelFrameText: 'Texte du cadre',
    labelFrameColor: 'Couleur du cadre',
    placeholder: 'Saisissez votre contenu ici...',
    placeholders: {
      url: 'https://example.com',
      text: 'Saisir le texte ici',
      email: 'vous@email.com',
      subject: 'Objet',
      message: 'Votre message...',
      phone: '+33 6 12 34 56 78',
      ssid: 'MonWiFi',
      password: '***',
      barcode: '123456789012',
    },
    download: 'Télécharger PNG',
    downloadSvg: 'Télécharger SVG',
    generateButton: 'Générer le QR code',
    copy: 'Copier le SVG',
    uploadLogo: 'Importer une image',
    preview: 'Aperçu',
    lowQuality: 'Basse qualité',
    highQuality: 'Haute qualité',
    foreverFree: 'Gratuit pour toujours • Sans inscription • Usage commercial',
    barcodeWarning: 'Les options avancées (cadres, logos) ne sont pas disponibles pour les codes‑barres.',
    barcodeColors: 'Vous pouvez tout de même personnaliser les couleurs ci‑dessous.',
    frameStyles: {
      none: 'Aucun',
      simple: 'Simple',
      balloon: 'Bulle',
      box: 'Boîte',
      badge: 'Badge',
      polaroid: 'Polaroid',
      phone: 'Téléphone',
      header: 'En-tête',
      corner: 'Coin',
    },
    vCard: {
      firstName: 'Prénom',
      lastName: 'Nom',
      mobile: 'Portable',
      phone: 'Téléphone',
      fax: 'Fax',
      email: 'E-mail',
      company: 'Entreprise',
      job: 'Intitulé du poste',
      street: 'Rue',
      city: 'Ville',
      zip: 'Code postal',
      state: 'État / Région',
      country: 'Pays',
      website: 'Site web',
    },
    types: {
      [QRType.URL]: 'URL',
      [QRType.TEXT]: 'Texte',
      [QRType.EMAIL]: 'E-mail',
      [QRType.PHONE]: 'Téléphone',
      [QRType.SMS]: 'SMS',
      [QRType.WIFI]: 'Wi‑Fi',
      [QRType.VCARD]: 'vCard',
      [QRType.FACEBOOK]: 'Facebook',
      [QRType.TWITTER]: 'X (Twitter)',
      [QRType.YOUTUBE]: 'YouTube',
      [QRType.BARCODE]: 'Code‑barres',
    },
    guide: {
      title: 'Comment créer un QR code personnalisé ?',
      steps: [],
    },
    gettingStarted: {
      title: 'Mode d’emploi',
      steps: [
        {
          title: 'Définir le contenu',
          text: 'Choisissez un type de contenu en haut (URL, Texte, E-mail...). Après sélection, vous verrez toutes les options disponibles. Renseignez tous les champs à afficher lors du scan. Vérifiez bien vos informations, car vous ne pourrez pas modifier le contenu une fois le QR code imprimé.',
        },
        {
          title: 'Personnaliser le design',
          text: 'Vous voulez un QR code unique ? Choisissez une couleur personnalisée et remplacez les formes standard des modules. Les coins et le corps peuvent être personnalisés séparément. Ajoutez un logo depuis la galerie ou importez votre propre image.',
        },
        {
          title: 'Générer le QR code',
          text: 'Réglez la résolution en pixels avec le curseur. Cliquez sur les boutons « Télécharger » pour enregistrer votre QR code. Assurez-vous qu’il fonctionne en scannant l’aperçu. Utilisez une haute résolution si vous voulez un PNG de qualité impression.',
        },
        {
          title: 'Télécharger l’image',
          text: 'Téléchargez votre QR code en .png, .svg ou .pdf. Pour un format vectoriel avec le design complet, choisissez .svg. Le SVG s’ouvre dans des logiciels comme Adobe Illustrator ou Inkscape. Le logo et certains réglages de design ne fonctionnent actuellement que pour .png et .svg.',
        },
      ],
    },
    about: {
      title: 'La suite QR gratuite, axée sur la confidentialité',
      subtitle:
        'Générez et scannez des QR codes de haute qualité sans compte, sans filigrane et sans envoi de données. Optimisé pour l’impression, la marque et l’usage commercial.',
      features: [
        'Tous les types populaires : URL, Texte, Wi‑Fi, vCard, SMS et codes‑barres',
        'Compatible logo avec jusqu’à 30 % de correction d’erreurs',
        'Formes, dégradés, couleurs et cadres personnalisés',
        'QR codes statiques qui n’expirent jamais',
        'Interface multilingue pour des équipes internationales',
      ],
      content: [
        {
          title: 'QR codes compatibles logo',
          body: 'Ajoutez un logo sans craindre les échecs de scan. Avec jusqu’à 30 % de correction d’erreurs, les superpositions restent lisibles pour emballages, menus et signalétique.',
        },
        {
          title: 'Formes et cadres personnalisés',
          body: 'Modifiez les coins, appliquez des dégradés et choisissez des cadres adaptés à votre campagne. Les contrôles orientés design gardent les codes scannables tout en restant fidèles à votre marque.',
        },
        {
          title: 'Plusieurs types de contenu',
          body: 'Générez des QR codes URL, texte, Wi‑Fi, vCard, SMS et codes‑barres depuis un seul endroit, avec des préréglages qui simplifient la configuration.',
        },
        {
          title: 'Des codes statiques qui durent',
          body: 'Créez des QR codes statiques qui n’expirent pas et ne limitent pas les scans — idéal pour les campagnes longue durée et les supports imprimés.',
        },
      ],
    },
    faq: {
      title: 'Questions fréquentes',
      items: [
        {
          q: 'Qu’est-ce qu’un QR code ?',
          a: 'QR signifie « Quick Response ». C’est un type de code‑barres inventé par Denso Wave en 1994.',
        },
        {
          q: 'Puis-je utiliser les QR codes générés à des fins commerciales ?',
          a: 'Oui, tous les QR codes créés avec ce générateur sont gratuits et peuvent être utilisés comme vous le souhaitez.',
        },
        {
          q: 'Les QR codes créés expirent-ils ?',
          a: 'Non, ils n’expirent pas et fonctionnent pour toujours ! Les QR codes créés avec YesQRCode sont statiques et ne cessent pas de fonctionner avec le temps. En revanche, vous ne pouvez pas modifier leur contenu après création.',
        },
        {
          q: 'Y a-t-il une limite de scans ?',
          a: 'Aucune limite : le QR code créé fonctionnera toujours. Scannez-le autant de fois que vous le souhaitez !',
        },
        {
          q: 'YesQRCode enregistre-t-il mes données ?',
          a: 'Nous ne sauvegardons ni ne réutilisons vos données. Nous mettons en cache vos images de QR code pendant 24 h sur notre serveur pour optimiser les performances de YesQRCode.',
        },
        {
          q: 'Pourquoi mon QR vCard n’affiche-t-il pas les bons champs ?',
          a: 'Tous les scanners QR ne suivent pas le standard vCard officiel, ce qui peut mélanger les champs de contact. Essayez une autre application de scan pour de meilleurs résultats.',
        },
        {
          q: 'Mon QR code ne fonctionne pas, que faire ?',
          a: 'Plusieurs raisons peuvent expliquer un mauvais fonctionnement. Vérifiez d’abord les données saisies : une petite faute dans l’URL peut casser le QR code. Certains formats (comme vCard) contiennent beaucoup de données : réduisez-les si possible. Essayez aussi de retirer le logo. Enfin, assurez-vous d’un contraste suffisant : le premier plan doit toujours être plus sombre que l’arrière‑plan.',
        },
        {
          q: 'YesQRCode fonctionne-t-il dans tous les navigateurs ?',
          a: 'YesQRCode nécessite un navigateur moderne compatible HTML5 et prend officiellement en charge Chrome, Firefox, Safari, Edge et Internet Explorer 11.',
        },
      ],
    },
  },
  scanner: {
    title: 'Scanner QR & codes‑barres',
    subtitle: 'Utilisez la caméra, importez une image ou collez pour décoder instantanément QR et codes‑barres.',
    cameraPermission: 'Accès caméra refusé. Activez les autorisations dans les réglages de votre navigateur.',
    result: 'Résultat',
    copy: 'Copier',
    copied: 'Copié',
    open: 'Ouvrir le lien',
    delete: 'Supprimer',
    scanAgain: 'Scanner à nouveau',
    privacy: 'Le traitement se fait localement dans votre navigateur. Les fichiers ne quittent jamais votre appareil.',
    upload: 'Importer une image',
    paste: 'Coller (Ctrl+V)',
    drop: 'Déposez l’image ici',
    retry: 'Réessayer',
    errorAccessDenied: 'Accès caméra refusé',
    errorCamera: 'Autorisez l’accès à la caméra dans les paramètres du navigateur.',
    initializing: 'Initialisation de la caméra...',
    cameraActive: 'Caméra active',
    scannedItems: 'Éléments scannés',
    recentScans: 'Récents (stockés localement)',
    clickToUpload: 'Cliquer pour importer',
    newBadge: 'NOUVEAU',
    tabCameraMobile: 'Caméra',
    tabCameraDesktop: 'Scanner via la caméra',
    emptyState: {
      title: 'Aucun scan pour le moment',
      desc: 'Importez une image ou utilisez l’onglet caméra pour commencer.',
    },
    highlights: {
      title: 'Scan rapide et privé',
      items: [
        { title: 'Décodage sur l’appareil', desc: 'Aucun upload par défaut ; idéal pour des URL ou contenus sensibles.' },
        { title: 'Multi‑formats', desc: 'QR + UPC/EAN, Code 128, ITF, et plus.' },
        { title: 'Actions rapides', desc: 'Déposez des fichiers, collez des captures, ou passez au scan en direct.' },
        { title: 'Parfait sur mobile', desc: 'Interface et flux caméra optimisés pour petits écrans.' },
      ],
    },
    intro: {
      title: 'Scanner QR & codes‑barres en ligne',
      body: 'Décodez des QR codes, UPC, EAN et plus directement dans votre navigateur, sans installer d’application.',
    },
    howTo: {
      title: 'Comment scanner ?',
      methods: [
        {
          title: 'Méthode 1 : Importer',
          steps: ['Cliquer sur Importer une image', 'Sélectionner votre QR/code‑barres', 'Obtenir le résultat instantanément'],
        },
        {
          title: 'Méthode 2 : Caméra',
          steps: ['Ouvrir l’onglet Caméra', 'Accorder l’autorisation', 'Pointer vers votre QR/code‑barres'],
        },
      ],
    },
    features: {
      title: 'Pourquoi utiliser ce scanner ?',
      items: [
        { title: 'Historique local', desc: 'Les scans récents restent sur votre appareil, prêts à copier ou ouvrir.' },
        { title: 'Décodage d’images hors ligne', desc: 'Importez/collez des images même si votre connexion coupe.' },
        { title: 'Actions instantanées', desc: 'Copiez, ouvrez ou supprimez les résultats via des contrôles simples.' },
      ],
    },
    useCases: {
      title: 'Cas d’usage populaires',
      items: [
        { title: 'Commerce & achats', desc: 'Vérifiez des URLs produit, coupons ou notices.' },
        { title: 'Équipes inventaire', desc: 'Vérifiez les codes‑barres et mettez à jour les stocks.' },
        { title: 'Utilisateurs au quotidien', desc: 'Ouvrez rapidement des menus, liens Wi‑Fi ou cartes de contact.' },
      ],
    },
    faq: {
      title: 'FAQ du scanner',
      items: [
        { q: 'Puis-je scanner des codes‑barres ?', a: 'Oui, le scanner prend en charge les QR codes ainsi que Code 128, UPC, EAN, ITF, et plus.' },
        { q: 'Stockez-vous mes scans ?', a: 'Aucun scan ne quitte votre navigateur ; tout reste sur votre appareil.' },
        { q: 'Puis-je coller des captures d’écran ?', a: 'Oui, utilisez Ctrl+V (Cmd+V) pour coller depuis le presse‑papiers.' },
        { q: 'Fonctionne-t-il hors ligne ?', a: 'L’import d’images fonctionne hors ligne ; le scan caméra nécessite une autorisation et un navigateur compatible.' },
      ],
    },
  },
  blog: {
    title: 'Analyses & guides',
    subtitle: 'Bonnes pratiques, idées marketing et mises à jour produit sur les expériences QR.',
    readMore: "Lire l'article",
    back: 'Retour au blog',
    notFound: 'Article introuvable',
  },
  common: {
    footer: 'Une suite puissante de création de QR codes pour marketeurs, designers et équipes.',
    privacy: 'Confidentialité',
    terms: 'Conditions',
    contact: 'Contact',
    scanToOpen: 'Scanner pour ouvrir sur mobile',
    help: 'Aide',
    free: 'Gratuit',
    product: 'Produit',
    resources: 'Ressources',
    company: 'Entreprise',
    api: 'API (bientôt)',
    systemStatus: 'Systèmes opérationnels',
    footerDesc:
      'Le générateur et scanner de QR codes le plus avancé. Rapide, axé sur la confidentialité, et gratuit pour toujours pour un usage personnel et commercial.',
  },
};
